var m = require('mithril');
var prop = require('mithril/stream');
var slimdown = require('slimdown-js');
var sanitizeMarkdownHtml = require('../../libs/sanitizeMarkdownHtml');
require('../../../stylesheets/mark-down/markdown.css');
var edit = require('../../layout/components/edit');
var heading = require('../../components/heading');
var modalForm = require('../../layout/components/modalForm');
var helpModal = require('../../help/helpModal');
var elementForm = modalForm(require('../../dashboards/models/element'));

var oninit = function(vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.elementText = prop(ctrl.element.markdownText || '');
  
  switch (ctrl.element.height) {
    case "1":
      ctrl.heigthClass = 'dn';
      break;
    case "2":
      ctrl.heigthClass = 'h4';
      break;
    case "3":
      ctrl.heigthClass = 'h5';
      break;
    case "4":
      ctrl.heigthClass = '';
      break;
    default:
      ctrl.heigthClass = 'h3';
  }
}

var view = function(vnode) {
  var ctrl = this;
  if (edit.vm.editing()) {
    return m('div.f3.fw2.narrow', [
      m(heading, {
        label: ctrl.element.name, 
        class: 'f1', 
        element: ctrl.element, 
        parentReinitialize: ctrl.parentReinitialize, 
        dashboardCallback: ctrl.dashboardCallback,
        datasetRepresentation: vnode.attrs.datasetRepresentation
      }),
      m('textarea.blue', {
        readonly: true,
        style: {resize: 'none'},
        id:'comment',
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        onclick: elementForm.editDialogue.bind(elementForm, ctrl.element , {delete:'true', move:'true', submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback}),
        value: ctrl.elementText()
      })
    ])
  } else {
    return m(`div.f3.pointer`,[
      ctrl.element.name ? 
        m(heading, {
          label: ctrl.element.name, 
          class: 'f1 blue', 
          element: ctrl.element, 
          parentReinitialize: ctrl.parentReinitialize, 
          dashboardCallback: ctrl.dashboardCallback,
          onClikLabel: () => {
            helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.markdownText || '');
          }
        },[
          ctrl.element.helpText ?
            m('i.ion-ios-information-outline.white.f1.ml2', {
              onclick: () => {
                helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
              }
            })
          : ''
        ]) 
      : '',
      m(`div.markdown-content.${ctrl.heigthClass}`, {
        onclick: () => {
          helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.markdownText || '');
        }
      },[
        m('div.markdown-body.mw8', { style: {
          'background': 'none',
        } }, [
          m.trust(sanitizeMarkdownHtml(slimdown.render(ctrl.elementText())))
        ])
      ])
    ])
  }
}

var oncreate = function(vnode) {
  var images = vnode.dom.querySelectorAll("img");
  images.forEach(img => {
    img.onload = function() {
      m.redraw();
    };
  });

}
module.exports = {oninit: oninit, view: view, oncreate};
